export enum OpcoesServicosEnum {
  EMPLACAMENTO = "EMPLACAMENTO",
  VISTORIA = "VISTORIA",
}
